<template>
  <bvue-ui-view :scroll="true" class="border-radius flex flex-col">
    <div class="flex justify-end">
      <button class="icon icon-cross icon-2x mt-2" @click="$bvueUi.modal.close()"></button>
    </div>
    <h2>{{ $t('apadrinarunarbol') }}</h2>
    <div class="flex-1 flex flex-col items-center mt-2">
      <div class="greyBox w-full flex items-center">
        <label class="flex-1 ml-2">{{reserve.name}}</label>
        <div class="chip mr-2 flex" style="background-color: white; color:#332402">
          <label class="mr-4 font-bold">{{ $t('tussemillas') }}</label>
           <img :src="require('@/assets/images/seed.svg')" class="seedImg mr-1">
          <label>{{seeds.length}}</label>
        </div>
      </div>
      <div class="flex-1 flex flex-col items-center">
        <div class="flex-1 my-1" style="width: 1px; border: solid 1px #c7c7c7;" />
          <label v-if="seeds.length > 0" class="text-center" style="max-width:300px;">{{ $t('utilizarsemillas') }}</label>
          <label v-else class="text-center" style="max-width:300px;">{{ $t('necesitasunasemilla') }} “{{reserve.name}}” {{ $t('paraplantar') }}</label>
        <div class="flex-1 my-1" style="width: 1px; border: solid 1px #c7c7c7;" />
      </div>
      <div v-if="seeds.length > 0" class="w-full flex justify-center mb-5">
        <div class="flex">
          <img :src="require('@/assets/images/tree_icon_planted.svg')" class="tree-icon mr-2"/>
          <div class="flex flex-col">
            <label><b>{{modalData.specie.name}}</b></label>
            <label>{{ $t('disponibleplantar') }}</label>
          </div>
        </div>
      </div>
    </div>
    <button v-if="seeds.length > 0" :class="['btn', 'btn-primary', 'w-full', loading]"  @click="plant">{{ $t('plantarsemilla') }}</button>
    <div v-else class="flex flex-col items-center">
      <button class="btn btn-primary w-full" @click="buySeeds">{{ $t('donar') }}</button>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
import BuySeeds from '@/components/modals/BuySeeds'
export default {
  name: 'PlantTree',
  props: {
    modalData: {
      type: Object,
      required: true 
    },
  },
  mounted() {
    this.$ga.page('/Plantar Arbol');
  },
  data() {
    return {
      loading: [],
      terms: false
    }
  },
  computed: {
    userId() {
      if (this.$store.state.auth.user) {
        return this.$store.state.auth.user.uid
      }
      return null
    },
    reserve() {
      if (this.$store.state.reserves.items) {
        return this.$store.state.reserves.items[this.modalData.reserveId] || {}
      }
      return {}
    },
    treePlanted() {
      if (this.reserve) {
        for (const seedKey in this.reserve.seeds) {
          const seed = this.reserve.seeds[seedKey];
          if (seed.planted && seed.planted.treeId === this.modalData.treeId) {
            console.log('Planted!!!: ', seed.planted)
            return seed.planted
          }
        }
      }
      return null
    },
    seeds() {
      return this.$store.getters.reserveUserSeeds(this.modalData.reserveId)
    }
  },
  methods: {
    async plant() {
      console.log('Plant')
      if (this.seeds.length > 0) {
        this.loading = ['loading', 'disabled']
        //Check not planted
        if (this.treePlanted) {
          console.log('tree planted: ', this.treePlanted)
          this.$dialogs.alert('No puedes apadrinar este árbol porque ya ha sido apadrinado por otra persona...', {title: 'Ya ha sido apadrinado', okLabel: ''} )
          this.$bvueUi.modal.close()
          return
        }
        const seed = this.seeds[0]
        const planted = {
          date: new Date().getTime(),
          ownerId: this.$store.state.auth.user.uid,
          treeId: this.modalData.treeId
        }
        const response = await firebase.firestore.collection('reserves').doc(this.modalData.reserveId).collection('seeds').doc(seed.id).update({planted: planted})
        //Message of congratulations
        this.$bvueUi.modal.close()
        this.loading = []
      } else {
        // This never should happen
        console.log('No seeds: ', this.seeds)
        this.$bvueUi.modal.close()
      }
    },
    buySeeds() {
      this.$bvueUi.modal.show({
        component: BuySeeds,
        width: 600,
        height: 500,
        data: {
          reserveId: this.modalData.reserveId
        }
      })
    }
  }
}
</script>

<style>
.greyBox {
  background-color: rgba(255,204,0,0.3);
  border-radius: 10px;
}
.toright {
  left: 68%;
  font-size: 1.2rem;
  color:#e2e8f0; 
}
</style>



// WEBPACK FOOTER //
// src/components/modals/PlantTree.vue